import React from 'react'
import classnames from 'classnames'

const GraphSVG = ({ className }) => {
  return (
    <svg
      viewBox="0 0 43 32"
      className={classnames('dealmed-icon', className)}
      aria-hidden={true}
      focusable={false}
    >
      <path d="M42 29.333h-39.333v-28.667c0-0.368-0.298-0.667-0.667-0.667h-1.333c-0.368 0-0.667 0.298-0.667 0.667v30c0 0.737 0.597 1.333 1.333 1.333h40.667c0.368 0 0.667-0.298 0.667-0.667v-1.333c0-0.368-0.298-0.667-0.667-0.667zM8.195 16.586c-0.26 0.26-0.26 0.682 0 0.942l0.943 0.943c0.26 0.26 0.682 0.26 0.942 0l6.058-6.001 7.057 7.058c0.521 0.521 1.365 0.521 1.886 0l7.794-7.794 3.67 3.67c0.413 0.412 0.919 0.597 1.417 0.597 1.040 0 2.038-0.808 2.038-2.028v-9.956c0-0.745-0.604-1.349-1.349-1.349h-9.956c-1.803 0-2.706 2.18-1.431 3.455l3.726 3.726-6.852 6.852-7.052-7.052c-0.519-0.519-1.36-0.521-1.881-0.004l-7.010 6.943zM30.247 5.333h7.087v7.087l-7.087-7.087z"></path>
    </svg>
  )
}

export default GraphSVG
